import TestimonialCard from '~/components/Molecules/TestimonialCard/TestimonialCard.vue'

export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    const isEnglish = this.$i18n.locale === 'en'

    return {
      //isMobile: null,
      card: TestimonialCard,
      swiperOptions: {
        watchOverflow: true,
        observer: true,
        slidesPerView: 1.2,
        spaceBetween: 24,
        grabCursor: true,
        breakpoints: {
          480: {
            slidesPerView: 1.8,
            spaceBetween: 28,
          },
          845: {
            slidesPerView: isEnglish ? 2 : 3,
            spaceBetween: 28,
          },
          1280: {
            slidesPerView: isEnglish ? 2 : 3,
            spaceBetween: 28,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
}
